import React from "react";
import { FaSignOutAlt, FaUserCircle } from "react-icons/fa";

export default function NavbarAccountMenu({
  effectiveUser,
  permissionsLoaded,
  initials,
  brandBg,
  accountRef,
  accountOpen,
  setAccountOpen,
  onAdminAccess,
  onLogout,
}) {
  return (
    <div className="relative" ref={accountRef}>
      <button
        type="button"
        onClick={() => setAccountOpen((value) => !value)}
        aria-label="Mon compte"
        className="inline-flex h-11 items-center gap-2 rounded-2xl bg-white/10 px-3 transition hover:bg-white/20"
      >
        <span
          className="flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold text-white"
          style={brandBg}
        >
          {initials}
        </span>

        <span className="hidden text-sm font-bold text-white md:inline">
          Administration
        </span>
      </button>

      {accountOpen && (
        <div className="absolute right-0 z-50 mt-3 w-72 overflow-hidden rounded-3xl border border-white/10 bg-slate-950 text-white shadow-2xl shadow-black/30">
          <div className="border-b border-white/10 px-5 py-4 text-sm">
            <p className="font-bold">
              {effectiveUser?.prenom ||
                effectiveUser?.displayName ||
                "Administrateur"}
            </p>
            <p className="mt-1 truncate text-white/65">{effectiveUser?.email}</p>
          </div>

          <button
            type="button"
            onClick={onAdminAccess}
            disabled={!permissionsLoaded}
            className="flex w-full items-center gap-3 px-5 py-4 text-left text-base font-bold transition hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <FaUserCircle className="h-5 w-5" />
            Tableau de bord
          </button>

          <button
            type="button"
            onClick={onLogout}
            className="flex w-full items-center gap-3 px-5 py-4 text-left text-base font-bold transition hover:bg-white/10"
          >
            <FaSignOutAlt className="h-5 w-5" />
            Se déconnecter
          </button>
        </div>
      )}
    </div>
  );
}